import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import DataDrift from "components/Monitoring/DataDrift";
import * as monitoringReducer from "containers/Monitoring/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";

import * as nextReducer from "containers/Next/NextReducer";
import * as nextMonitoringReducer from "containers/Next/Monitoring/NextMonitoringReducer";

class DataDriftContainer extends React.Component {
  render() {
    return <DataDrift {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const nextId = dispatch((dispatch, getState) => {
    return nextReducer.getNextIdFromProjectId(getState(), ownProps.id);
  });
  return {
    updateDataDriftWarningThreshold: (threshold) =>
      dispatch(nextMonitoringReducer.updateDataDriftWarningThreshold(nextId, threshold)),
    updateModelDriftWarningThreshold: (threshold) =>
      dispatch(nextMonitoringReducer.updateModelDriftWarningThreshold(nextId, threshold)),
    updateModelDriftWarningTargets: (targets) =>
      dispatch(nextMonitoringReducer.updateModelDriftWarningTargets(nextId, targets))
  };
};

const mapStateToProps = (state, ownProps) => {
  const nextId = nextReducer.getNextIdFromProjectId(state, ownProps.id);
  const overallRunId = projectReducer.getOverallRunId(state, ownProps.id);
  return {
    monitoringData: monitoringReducer.getData(state, ownProps.id),
    dataDriftWarningThreshold: nextMonitoringReducer.getDataDriftWarningThreshold(state, nextId),
    modelDriftWarningThreshold: nextMonitoringReducer.getModelDriftWarningThreshold(state, nextId),
    modelDriftWarningTargets: nextMonitoringReducer.getModelDriftWarningTargets(state, nextId),
    dataDrift: monitoringReducer.getDataDrift(state, ownProps.id),
    modelDrift: monitoringReducer.getModelDrift(state, ownProps.id),
    setupLabels: setupReducer.getSetupLabels(state, overallRunId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DataDriftContainer);
